export function formatTimeTo12Hour(time: string): string {
    const [hours, minutes] = time.split(':').map(Number);
    if (isNaN(hours) || isNaN(minutes)) return time;

    const period = hours >= 12 ? 'PM' : 'AM';
    const formattedHours = hours % 12 || 12;
    return `${formattedHours}:${minutes.toString().padStart(2, '0')} ${period}`;
}

export function getTodayDate(): any {
    const today = new Date();
    return today.toLocaleDateString('en-CA');
}